export default __webpack_public_path__ + "static/media/twitterDesk.0a2fca38.svg";